import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { 
  PackageCheck,
  Ruler,
  Recycle,
  Palette
} from 'lucide-react';

const ProductCategory2 = () => {
  const features = [
    {
      icon: PackageCheck,
      title: "Quality Construction",
      description: "Premium kraft paper construction with reinforced bottom for excellent stability and durability.",
      color: "#4CAF50" // Green background
    },
    {
      icon: Ruler,
      title: "Size Options",
      description: "Available in various sizes from small retail bags to large shopping bags, meeting all your packaging needs.",
      color: "#FF9800" // Orange background
    },
    {
      icon: Recycle,
      title: "Eco-Friendly",
      description: "100% recyclable and biodegradable materials, perfect for environmentally conscious businesses.",
      color: "#2196F3" // Blue background
    },
    {
      icon: Palette,
      title: "Brand Ready",
      description: "Smooth surface ideal for custom printing, helping you showcase your brand with style.",
      color: "#E91E63" // Pink background
    }
  ];

  return (
    <div className="container py-5">
      <div className="text-center mb-5">
        <h2 className="main-heading display-5 fw-bold mb-3">Discover Features</h2>
        <p className="product-each-desc text-muted mx-auto" style={{ maxWidth: '700px' }}>
          Our paper bags combine durability with sustainability, offering versatile packaging solutions for retail, food service, and promotional needs.
        </p>
      </div>

      <div className="row g-4">
        {features.map((feature, index) => {
          const IconComponent = feature.icon;
          return (
            <div key={index} className="col-12 col-sm-6 col-lg-3">
              <div className="card h-100 border-0 shadow-sm feature-card">
                <div className="text-center mt-4">
                  <div 
                    className="icon-container d-inline-flex align-items-center justify-content-center rounded-3 mb-4"
                    style={{ background: feature.color }}
                  >
                    <IconComponent size={40} className="icon-img" />
                  </div>
                </div>
                
                <div className="card-body text-center">
                  <h3 className="card-title h5 mb-3">{feature.title}</h3>
                  <p className="card-text text-muted mb-4">{feature.description}</p>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <style>
        {`
          .feature-card {
            transition: all 0.3s ease;
            position: relative;
            overflow: hidden;
          }

          .feature-card::after {
            content: '';
            position: absolute;
            bottom: 0;
            left: 0;
            width: 0;
            height: 3px;
            background-color: #dc3545;
            transition: width 0.3s ease;
          }

          .feature-card:hover {
            transform: translateY(-10px);
          }

          .feature-card:hover::after {
            width: 100%;
          }

          .icon-container {
            width: 80px;
            height: 80px;
            transition: all 0.3s ease;
          }

          .icon-img {
            color: white;
          }

          .feature-card:hover .icon-container {
            transform: scale(1.1);
          }
        `}
      </style>
    </div>
  );
};

export default ProductCategory2;